/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Wrapped_Dialog_LabelInputs */

const en_us2_wrapped_dialog_label = /** @type {(inputs: Wrapped_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Your retrospective`)
};

const pt_br2_wrapped_dialog_label = /** @type {(inputs: Wrapped_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Sua retrospectiva`)
};

const es_419_wrapped_dialog_label = /** @type {(inputs: Wrapped_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Tu resumen`)
};

const pt_pt2_wrapped_dialog_label = /** @type {(inputs: Wrapped_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A tua retrospetiva`)
};

const fr_fr2_wrapped_dialog_label = /** @type {(inputs: Wrapped_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ton bilan`)
};

const de_de2_wrapped_dialog_label = /** @type {(inputs: Wrapped_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Dein Rückblick`)
};

const it_it2_wrapped_dialog_label = /** @type {(inputs: Wrapped_Dialog_LabelInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Il tuo riepilogo`)
};

/**
* | output |
* | --- |
* | "Your retrospective" |
*
* @param {Wrapped_Dialog_LabelInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const wrapped_dialog_label = /** @type {((inputs?: Wrapped_Dialog_LabelInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Wrapped_Dialog_LabelInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_wrapped_dialog_label(inputs)
	if (locale === "es-419") return es_419_wrapped_dialog_label(inputs)
	if (locale === "pt-PT") return pt_pt2_wrapped_dialog_label(inputs)
	if (locale === "fr-FR") return fr_fr2_wrapped_dialog_label(inputs)
	if (locale === "de-DE") return de_de2_wrapped_dialog_label(inputs)
	if (locale === "it-IT") return it_it2_wrapped_dialog_label(inputs)
	return en_us2_wrapped_dialog_label(inputs)
});
export { wrapped_dialog_label as "wrapped.dialog_label" }